async function checkCartAvailibility() {
  // Get the cart items
  const response = await fetch("/cart.js");
  let cartItems = await response.json();
  cartItems = cartItems.items;

  // Function to send a request for each cart item
  const sendRequest = async (item) => {
    try {
      const response = await fetch(
        zapietGadgetAppBaseUrl + "isAvailable",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            productVariantId: item.variant_id,
            quantity: item.quantity,
          }),
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error sending request:", error);
      throw error;
    }
  };

  // Create an array of promises for each cart item
  const promises = cartItems.map(sendRequest);

  // Wait for all promises to resolve
  return Promise.all(promises)
    .then((results) => {
      return results;
    })
    .catch((error) => {
      console.error("Error in Promise.all:", error);
    });
}

$(document).ready(function () {
    let hasSalesPlan = document.querySelector(".cart-has-sales-plan");
  let firstTime = true;
    let storeSelected = false;
  window.ZapietEvent.listen("widget_loaded", async function (params) {
        hasSalesPlan = document.querySelector(".cart-has-sales-plan");
    firstTime = true;
       storeSelected = false;

  });
 
  window.ZapietEvent.listen("selected_method", async function (method) {
    document
      .querySelector("#CheckOut")
      .classList.add("disable-checkout-button");

      if (method == "pickup") {
        document.querySelector("#gsAppContainer").style.display = "none";
      } else {
        document.querySelector("#gsAppContainer").style.display = "block";
      }

      
    if (method == "pickup") {
      await checkPickupAvalibility();
    }
    // Last selected method and default method selection
    window.ZapietEvent.listen("checkoutEnabled", async function (params) {
      let selectedStore = localStorage.getItem("selected-store");
      if (firstTime) {
        firstTime = false;
        let selectedMethod = localStorage.getItem("selected-method");
        if (selectedMethod !== null && selectedMethod !== "") {
          Zapiet.setCheckoutMethod(selectedMethod);
          if (selectedMethod == "pickup") {
            await checkPickupAvalibility();
          }
        } else if (selectedStore !== null && selectedStore !== "") {
          localStorage.setItem("selected-method", "shipping");
          Zapiet.setCheckoutMethod("shipping");
          // await checkPickupAvalibility();
        } else {
          localStorage.setItem("selected-method", "shipping");
          Zapiet.setCheckoutMethod("shipping");
        }
        removeOldErrorMessages();
      }
    });
    removeOldErrorMessages();
  });

  window.ZapietEvent.listen("checkoutEnabled", async function (params) {
    document
      .querySelector("#CheckOut")
      .classList.remove("disable-checkout-button");
    if (params.method == "pickup") {
      document.querySelector("#gsAppContainer").style.display = "none";
         if (hasSalesPlan == null) {
           console.log("Test")
        document
        .querySelector("#CheckOut")
        .classList.remove("disable-checkout-button");

      }else{
        document
        .querySelector("#CheckOut")
        .classList.add("disable-checkout-button");
        errorDiv = document.createElement("div");
        errorDiv.innerHTML = `
        <p role="alert" class="error">Sorry, pick up is not available for Subscribe & Save products</p>
        `;
        errorDiv.id = "not-available-message";
       document.querySelector('#not-available-message')?.remove();
        document.querySelector(".checkoutMethodContainer.pickup").appendChild(errorDiv);
                   document.querySelectorAll(".not-available-error-cart").forEach((item) => item.remove());
           document.querySelectorAll(".cart-has-sales-plan").forEach((item) => {
          let target = item.closest("[data-js-cart-item]").querySelector(".cart-item__variants");
          target.insertAdjacentHTML(
            "afterend",
            `<small  class='not-available-error-cart'> Pick up is not available for this Subscribe & Save product </small>`
          );
        }
        );
        return;
      }
      localStorage.setItem("selected-method", params.method);
            if (!storeSelected) {
      selectCurrentStoreOnWidget();
                      storeSelected = true;
            }
      document.querySelectorAll(".location.clearfix").forEach((item) => {
        item.addEventListener("click", () => {
          removeOldErrorMessages();
        });
      });
    }
    let selectedMethod = localStorage.getItem("selected-method");
    if (
      (params.method == "shipping" && !firstTime) ||
      selectedMethod == "shipping"
    ) {
      document.querySelector("#gsAppContainer").style.display = "block";

      document
        .querySelector("#CheckOut")
        .classList.add("disable-checkout-button");

      const shippingContainer = document.querySelector(
        ".checkoutMethodContainer.shipping"
      );
      shippingContainer.innerHTML = "";

      localStorage.setItem("selected-method", params.method);
      const checkoutButton = document.querySelector("#CheckOut");

      let availability = await checkCartAvailibility();
      let unavailableProducs = availability.filter(
        (item) => item.available === false
      );
      if (unavailableProducs.length > 0) {
        document.querySelector("#not-available-message")?.remove();
        const messageDiv = document.createElement("div");
        messageDiv.innerHTML = `
              <p role="alert" class="error">Sorry, shipping is not available for your selected item.</p>
          `;
        messageDiv.id = "not-available-message";

        shippingContainer.appendChild(messageDiv);
        const notAvailableErrors = document.querySelectorAll(
          ".not-available-error-cart"
        );
        notAvailableErrors.forEach((item) => item.remove());
        unavailableProducs.forEach((item) => {
          // const productTitle = document.querySelector(
          //   `[data-product-id="${item.productId}"] .cart-item__title`
          // );
          const productTitle = document.querySelector(
            `[data-variant-id="${item.productVariantId}"] .cart-item__title`
          );
          
          productTitle.insertAdjacentHTML(
            "afterend",
            `<small  class='not-available-error-cart'>Product unavailable</small>`
          );
        });
      } else {
        document
          .querySelector("#CheckOut")
          .classList.remove("disable-checkout-button");
      }
    }
  });
});

function selectCurrentStoreOnWidget() {
  let selectedStore = localStorage.getItem("selected-store");
  if (selectedStore && selectedStore !== "") {
    let locations = document.querySelectorAll(".ZapietStack-Item .name");
    let searchString = selectedStore;

    let found = false;
    for (let i = 0; i < locations.length; i++) {
      if (locations[i].textContent.trim() === searchString) {
        found = true;
        locations[i].click();
        break;
      }
    }
    if (!found) {
      let widgetText = document.querySelector(
        ".ZapietStack-Item.ZapietStack-Item--fullWidth p"
      );
      widgetText.classList.add("error");
      widgetText.role = "alert";
      widgetText.innerHTML = `${selectedStore} is currently unavailable. Please select another store.`;
      if (locations.lenght < 1) {
               document
          .querySelector("#CheckOut")
          .classList.add("disable-checkout-button");
      }
    }
  }
}
function removeOldErrorMessages() {
  document.querySelector("#not-available-message")?.remove();
  document
    .querySelectorAll(".not-available-error-cart")
    .forEach((item) => item.remove());
}

async function checkPickupAvalibility() {
  const response = await fetch("/cart.js");
  let cartItems = await response.json();
  cartItems = cartItems.items;
  const promises = cartItems.map((item) => {
    return fetch(
      "https://api-us.zapiet.com/v1.0/pickup/locations?shop=" + zapietShopUrl,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shoppingCart: [
            {
              product_id: item.product_id,
              variant_id: item.variant_id,
              quantity: item.quantity,
            },
          ],
        }),
      }
    );
  });
  // wait for all promises to resolve
  Promise.all(promises)
    .then((results) => {
      return Promise.all(results.map((r) => r.json()));
    })
    .then((results) => {
      if (results.length > 0) {

        document
          .querySelector("#CheckOut")
          .classList.remove("disable-checkout-button");
        results.forEach((item, index) => {
          let selectedStore = localStorage.getItem("selected-store");
          if (selectedStore == null || selectedStore == "") {
            return;
          }
          const hasCompanyName = item.locations.some(
            (item) => item.company_name == selectedStore
          );

          if (!hasCompanyName) {
            document
              .querySelector("#CheckOut")
              .classList.add("disable-checkout-button");
            const productTitle = document.querySelector(
              //`#item-${cartItems[index].id} .cart-item__title`
              `[data-cart-id="${index}-${cartItems[index].variant_id}"] .cart-item__title`
            );
            productTitle.insertAdjacentHTML(
              "afterend",
              `<small style="color:red; font-size:12px;" class='not-available-error-cart'>Product unavailable in ${selectedStore}</small>`
            );

          } else {
              for (let i = 0; i < item.locations.length; i++) {
                if (item.locations[i].company_name === selectedStore) {
                   var location_id = item.locations[i].id;
                   document.querySelector("#location_"+location_id).click();
                  break;
                }
               }
          }
          
        });
      } else {
        document
          .querySelector("#CheckOut")
          .classList.remove("disable-checkout-button");
      }
    })
    .catch((error) => {
      console.error("Error in Promise.all:", error);
    });
}
